import { render, staticRenderFns } from "./rescueRegionChar.vue?vue&type=template&id=1b1775ce&"
import script from "./rescueRegionChar.vue?vue&type=script&lang=js&"
export * from "./rescueRegionChar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports